'use client'

import { useAction } from 'next-safe-action/hooks'

import { verifyEmail as _verifyEmail } from '@/entities/auth'
import { CERT } from '@/shared/api'
import { useServerErrorHandler } from '@/shared/config/action'

type ActionProps = {
  onSuccess: (emailCertToken: string) => void
  onError: (errorMessage: string) => void
}

export const useVerifyEmail = () => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_verifyEmail)

  const verifyEmailAsync = async (
    email: string,
    certCode: string,
    { onSuccess, onError }: ActionProps,
  ) => {
    const result = await action.executeAsync({ email, certCode })

    if (result?.serverError) {
      const { code, content } = result.serverError

      if (code === CERT['008'] || code === CERT['009']) {
        onError(content)
      } else {
        handleServerError(result.serverError)
      }

      return
    }

    if (result?.data?.emailCertToken) {
      onSuccess(result.data.emailCertToken)
    }
  }

  return { verifyEmailAsync, isVerifying: action.isExecuting }
}
